<template>
  <b-modal
    id="modalWarning"
    hide-header
    hide-footer
    modal-class="success-submit-modal"
    ignore-enforce-focus-selector=".webim-root"
    @hidden="hideModal"
  >
    <div class="modal__wrapper warning__modal-wrapper">
      <div class="warning__top">
        <svg
          class="warning__svg"
          width="20"
          height="20"
        >
          <use xlink:href="#icon-warning" />
        </svg>
        <h3 class="warning__title">
          {{ title }}
        </h3>
      </div>
      <div
        class="modal__close warning__close"
        @click="() => { hideModal() }"
      />
      <div class="warning__text">
        {{ messageText }}
      </div>
      <button
        class="warning__btn"
        @click="hideModal"
      >
        {{ btnText }}
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'CalculatorModalWarning',
  props: {
    title: {
      type: String,
      required: true,
    },
    messageText: {
      type: String,
      required: true,
    },
    btnText: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.$bvModal.show('modalWarning');
  },
  methods: {
    hideModal() {
      this.$bvModal.hide('modalWarning');
      this.$emit('modal_warning_close');
    },
  },
};
</script>
<style lang="scss">
  @import './CalculatorModalWarning.scss';
</style>
